function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildComponentName } from '../utils';
import SpinElement from './spinElement.js';
var __vue_script__ = {
  name: buildComponentName('Spin'),
  components: {
    SpinElement: SpinElement
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-spin'
    },
    size: String,
    spinning: {
      type: Boolean,
      default: true
    },
    spinClass: [String, Object, Array],
    spinStyle: Object,
    wrapClass: [String, Object, Array],
    wrapStyle: Object,
    tip: String
  },
  computed: {
    isSpinning: function isSpinning() {
      return this.spinning;
    },
    spinClasses: function spinClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          tip = this.tip,
          size = this.size,
          isSpinning = this.isSpinning;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_ref, "".concat(prefixCls, "-spinning"), isSpinning), _defineProperty(_ref, "".concat(prefixCls, "-show-text"), !!tip), _ref;
    },
    containClasses: function containClasses() {
      var _ref2;

      var prefixCls = this.prefixCls,
          isSpinning = this.isSpinning;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-container"), true), _defineProperty(_ref2, "".concat(prefixCls, "-blur"), isSpinning), _ref2;
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return !_vm.$slots.default ? _c('spin-element', {
    class: [_vm.spinClasses, _vm.spinClass],
    style: _vm.spinStyle
  }, [_c('template', {
    slot: "indicator"
  }, [_vm._t("indicator", [_c('svg', {
    class: _vm.prefixCls + "-circle",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])], 2), _c('template', {
    slot: "tip"
  }, [_vm.tip || _vm.$slots.tip ? _c('div', {
    class: _vm.prefixCls + "-text"
  }, [_vm._t("tip", [_vm._v(" " + _vm._s(_vm.tip) + " ")])], 2) : _vm._e()])], 2) : _c('div', {
    class: [_vm.prefixCls + "-nested-loading", _vm.wrapClass],
    style: _vm.wrapStyle
  }, [_c('spin-element', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSpinning,
      expression: "isSpinning"
    }],
    class: [_vm.spinClasses, _vm.spinClass],
    style: [_vm.spinStyle]
  }, [_c('template', {
    slot: "indicator"
  }, [_vm._t("indicator", [_c('svg', {
    class: _vm.prefixCls + "-circle",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])], 2), _c('template', {
    slot: "tip"
  }, [_vm.tip || _vm.$slots.tip ? _c('div', {
    class: _vm.prefixCls + "-text"
  }, [_vm._t("tip", [_vm._v(" " + _vm._s(_vm.tip) + " ")])], 2) : _vm._e()])], 2), _c('div', {
    class: _vm.containClasses
  }, [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "spin.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;